<template>
  <div class="row justify-content-center no-gutters main-mr container-fluid">
    <div class="col-12">
      <div id="boards-section">
        <div class="row mb-3">
          <div class="col d-flex justify-content-between align-items-center">
            <h4 class="mb-0 fw-weight font-24 my-project-font-sm active">
              {{ $resourceString["account.SideBar.MyProjects.Title"] }}
            </h4>
            <div v-if="selectedTab === 'Archived' && showComponentpcBoardCard">
              <a
                class="btn call-to-action-button btn-primary px-0 justify-content-center"
                :class="{ disabled: isDisabled }"
                @click.prevent="handleDeleteTray"
              >
                {{ $resourceString["common.Button.Title.Delete"] }}
              </a>
              <a
                class=" capitalize-myProject btn call-to-action-button btn-primary px-0 justify-content-center ml-lg-3 "
                :class="{ disabled: isDisabled }"
                @click="handleArchiveTray"
              >
                {{ $resourceString["common.accounts.Label.Reactivate"] }}
              </a>

            </div>
            <add-button   v-if="selectedTab !== 'Archived'" :onClickHandler="createProject" :buttonText="buttonText"></add-button>

          </div>
        </div>

        <div class="row align-items-center mb-3">
          <div class="col-12 col-xl-7 col-lg-9 col-md-9 col-12 pr-0 pb-2">
            <pc-my-projects-tabs />
          </div>
        </div>
        <!-- // search bar  -->
        <div class="row">
          <pc-projects-search />
        </div>
        <div class="row pb-4 justify-content-end">
          <div class="col-12 col-xl-3 col-lg-3 col-md-3 col-12">
            <div
              class="d-flex h-100 align-items-center justify-content-center justify-content-end my-project-layout-sm"
            >
              <pc-layout-button :toggleLayout="toggleLayout" />
            </div>
          </div>
          <pc-project-sort-by />
        </div>
        <div class="col-lg-12 p-0">
          <pc-project-card
            v-if="showComponentpcBoardCard"
            :layoutToRenderIsSmall="layoutToRenderIsSmall"
            :isAdminMode="isAdmin"
          />
          <pc-project-list-view
            v-if="!showComponentpcBoardCard"
            :isAdminMode="isAdmin"
          />
          <!-- Loader -->
          <pc-load-more v-if="showLoadMore" :load-more="onLoadMore" />

          <!-- Bottom add item button -->
          <div class="row mt-5 mb-3 text-center">
            <div class="col-sm-12 mb-2">
                <add-button v-if="selectedTab !== 'Archived'" :onClickHandler="createProject" :buttonText="buttonText"></add-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal
      height="500"
      name="create-project-modal"
      data-html2canvas-ignore="true"
      :adaptive="true"
      :scrollable="true"
    >
      <pc-my-project-create-modal :trayId="null" />
    </modal>
    <modal height="650" name="project-upload-image-modal" data-html2canvas-ignore="true"
      :adaptive="true">
      <pc-project-upload-image-modal></pc-project-upload-image-modal>
    </modal>
  </div>
</template>
<script>
import PcMyProjectsTabs from "./pc-my-projects-tabs.vue";
import PcLayoutButton from "../my-trays-page/pc-layout-button.vue";
import PcProjectSortBy from "./pc-project-sort-by.vue";
import PcProjectCard from "./pc-project-card.vue";
import pcProjectListView from "./pc-project-list-view.vue";
import { mapActions, mapGetters } from "vuex";
import PcProjectsSearch from "./pc-projects-search.vue";
import PcLoadMore from "../common/pc-loading-more.vue";
import PcMyProjectCreateModal from "./pc-my-project-create-modal.vue";
import PcProjectUploadImageModal from "./pc-project-upload-image-modal.vue";
import addButton from "./my-project-add-button.vue"
export default {
  props: ["isAdmin"],
  data() {
    return {
      showComponentpcBoardCard: true,
      layoutToRenderIsSmall: false,
      buttonText: this.$resourceString['myProject.Project.NewProject.Title']
    };
  },

  computed: {
    ...mapGetters({
      selectedTab: "myTray/getselectedTabName",
      showLoadMore: "myTray/showLoadMore",
      getSelectedProjectId: "myTray/getSelectedTrayId",
      isFetching: "myTray/getLoader"
    }),

    isDisabled() {
      return this.getSelectedProjectId.length === 0;
    },

    addTrayHref() {
      return `/VirtualTray`;
    }
  },
  methods: {
    ...mapActions({
      deleteVirtualTray: "myTray/deleteVirtualTray",
      archiveVirtualTray: "myTray/archiveVirtualTray",
      loadMoreData: "myTray/loadMoreData",
      modalArchiveMsg: "myTray/modalArchiveMsg",
      startOver: "virtualTray/startOver",
      resourceString: "myTray/resourceString"
    }),

    handleAddTray() {
      localStorage.removeItem("tray");
    },

    showModal(name) {
      this.$modal.show(name + "-modal");
    },

    createProject() {
      this.showModal("create-project");
    },

    toggleLayout(layoutType) {
      this.layoutToRenderIsSmall = layoutType;
      switch (layoutType) {
        case this.$resourceString["common.LayoutButton.Title.SmallView"]:
          this.layoutToRenderIsSmall = true;
          this.showComponentpcBoardCard = true;
          break;
        case this.$resourceString["common.LayoutButton.Title.LargeView"]:
          this.layoutToRenderIsSmall = false;
          this.showComponentpcBoardCard = true;
          break;
        case this.$resourceString["common.LayoutButton.Title.ListView"]:
          this.layoutToRenderIsSmall = false;
          this.showComponentpcBoardCard = false;
        default:
          this.layoutToRenderIsSmall = false;
      }
    },

    async handleDeleteTray() {
      await this.resourceString(
        this.$resourceString["myProject.Project.Deleted.Msg"]
      );
      await this.deleteVirtualTray(this.getSelectedProjectId);
    },

    async handleArchiveTray() {
      await this.modalArchiveMsg(this.$resourceString["common.accounts.Label.Reactivate"]);
      await this.resourceString(
        this.$resourceString["myProject.Project.Reactivated.Msg"]
      );
      await this.archiveVirtualTray(this.getSelectedProjectId);
    },

    onLoadMore() {
      if (this.isFetching) {
        return;
      }
      this.loadMoreData();
    }
  },

  components: {
    PcMyProjectsTabs,
    PcLayoutButton,
    PcProjectSortBy,
    PcProjectCard,
    pcProjectListView,
    PcProjectsSearch,
    PcLoadMore,
    PcMyProjectCreateModal,
    PcProjectUploadImageModal,
    addButton
  }
};
</script>
